import React from "react";
import { dateFormatter } from "../_helpers/dateFormatter";
import { Spinner } from "react-bootstrap";

function CandidateCard({ candidatesList, changeStageHandler, stageLoading, userType }) {
  return (
    <>
      {
        stageLoading ?
          <tr>
            <td colSpan={5} className="align-middle">
              <div className="d-flex align-items-center justify-content-center w-100">
                <Spinner variant="primary" />
              </div>
            </td>
          </tr> :
          <>
            {Array.isArray(candidatesList?.results) && candidatesList.results.length ? (
              candidatesList?.results.map((item, itemIndex) => (
                <tr key={itemIndex}>
                  <td className="align-middle">
                    <div className="d-flex align-items-center">
                      <div className="d-flex candidate-info">
                        {/* <div className="candiate-img">
                          <img
                            src={
                              item?.candidate_details && item.candidate_details?.logo
                                ?  item?.candidate_details && item.candidate_details?.logo
                                : "/assets/images/user-img.png"
                            }
                            alt="candidate"
                          />
                        </div> */}
                        <div className="candiate-content">
                          <p className="font-weight-bold text-black mb-1 text-capitalize">
                            {item?.candidate_details?.full_name}
                          </p>
                          <p className="mb-0">
                            {item?.candidate_details?.email}
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="align-middle">
                    {item?.candidate_details?.skills.length ?
                      <ul className="d-flex align-items-center flex-wrap">
                        {item?.candidate_details?.skills?.map((skill, skillIndex) => (
                          <li
                            key={skillIndex}
                            className=" border bg-grey-2 rounded-lg fs-smallest font-weight-medium px-2 mr-2 my-1"
                          >
                            {skill}
                          </li>
                        )
                        )}
                      </ul>
                      : "Not Mentioned"}
                  </td>
                  {item?.interview_stage == "applied" &&
                    <>
                      <td className="align-middle">
                        {dateFormatter(item?.applied_date)}
                      </td>
                      <td className="align-middle">
                        {item?.resume !== null ?
                          <span>{item?.resume}</span> : "Not Available"
                        }
                      </td>
                      <td className="align-middle">
                        <button className="btn text-primary font-weight-medium p-0" onClick={() => changeStageHandler(item)}>Move to Next</button>
                      </td>
                    </>
                  }
                  {item?.interview_stage == "assessment" &&
                    <>
                      <td className="align-middle">
                        <span>{dateFormatter(item?.created)}</span>
                      </td>
                      <td className="align-middle">
                        {item?.assessment_kit_submitted_details && item.assessment_kit_submitted_details.length > 0 ?
                          item?.assessment_kit_submitted_details && item.assessment_kit_submitted_details.map((i) =>
                            <span className="custom-tag tag-assessment py-1 rounded-pill">{i?.interview_submitted == true ? "submitted" : "pending"}</span>
                          ) : <span className="custom-tag tag-assessment py-1 rounded-pill">not submitted</span>}
                      </td>
                      <td className="align-middle">
                        <button className="btn text-primary font-weight-medium p-0" onClick={() => changeStageHandler(item)}>Move to Next</button>
                      </td>
                    </>
                  }
                  {item?.interview_stage == "interview" &&
                    <>
                      <td className="align-middle">
                        <span>{dateFormatter(item?.updated)}</span>
                      </td>
                      <td className="align-middle">
                        <span className="custom-tag tag-interview py-1 rounded-pill">{item?.interview_details && item.interview_details.length > 0 ? "Scheduled" : "UnScheduled"}</span>
                      </td>
                      {userType !== "mentor" &&
                        <td className="align-middle">
                          <button className="btn text-primary font-weight-medium p-0" onClick={() => changeStageHandler(item)}>Move to Next</button>
                        </td>
                      }
                    </>
                  }

                  {item?.interview_stage == "offer" &&
                    <>
                      <td className="align-middle">
                        <span>{dateFormatter(item?.job_offer_details && item.job_offer_details?.created)}</span>
                      </td>
                      <td className="align-middle">
                        {item?.job_offer_details && item.job_offer_details?.offer_accepted == true ?
                          <span className="custom-tag tag-offer py-1 rounded-pill">Accepted</span> :
                          <span className="custom-tag tag-rejected py-1 rounded-pill">Rejected </span>}
                      </td>
                      {userType !== "mentor" &&
                        <td className="align-middle">
                          <button className="btn text-primary font-weight-medium p-0" onClick={() => changeStageHandler(item)}>Move to Next</button>
                        </td>
                      }
                    </>
                  }

                  {item?.interview_stage == "hired" &&
                    <>
                      <td className="align-middle">{dateFormatter(item?.updated)}</td>
                      <td className="align-middle">
                        <span className="custom-tag tag-green py-1 rounded-pill">Selected</span></td>
                      {userType !== "mentor" &&
                        <td className="align-middle">
                          <button className="btn text-primary font-weight-medium p-0" onClick={() => changeStageHandler(item)}>Move to Next</button>
                        </td>
                      }
                    </>
                  }
                  {item?.interview_stage == "rejected" &&
                    <>
                      <td className="align-middle">{dateFormatter(item?.updated)}</td>
                      <td className="align-middle">
                        <span className="custom-tag tag-rejected py-1 rounded-pill">rejected</span></td>
                    </>
                  }
                </tr>
              ))
            ) : (
              <tr key="emptyState">
                <td colSpan={5} className="align-middle text-center">
                  <h3 className="mb-2 text-danger my-3">
                    No Candidates Yet!
                  </h3>
                </td>
              </tr>
            )}
          </>
      }
    </>
  );
}

export default CandidateCard;
